import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import "./styles.scss"
import { Card, CardTitle } from "../../components/Card"
import { AlertIcon } from "../../components/ImageComponents"
import {
  Label,
  FormRow,
  Input,
  SelectInput,
  TextArea,
  SelectInputAsync,
} from "../../components/Form"
import { Button, ButtonLoader } from "../../components/Button"
import { numberMask, phoneMask } from "../../core/utils/validateFields"
import { Grid } from "../../components/Table"
import { LoadingWithLabel } from "../../components/Loading"
import { InputFileWithPreview } from "../../components/FileInput"
import { RadioButton } from "../../components/RadioButton"
import { isMobile } from "react-device-detect"
import { MdClose } from "react-icons/md"
import { InfoTooltip } from "../../components/Tooltip"
import { InfoTitle } from "../AssistanceLinkMessageScreen"
import { EvidenceBox, MessageBox } from "../../components/MessageBox"
import { ModalPanel } from "../../components/Modal"
import { Section } from "../../components/Section"
import NewChatContainer from "../../container/NewChatContainer"
import { BsChatText } from "react-icons/bs"
import { Warning } from "../../components/Warning"
import CameraGallery from "../../container/CameraGalleryContainer"
import { TableInput } from "../../components/TableInput"
import Overlay from "../../components/Overlay"

const baselineIds = [
  "c0616d35-3ce6-4dfb-94de-cb19a9cfb925",
  "fde0d60e-760f-48bb-aee4-a2bc18c4766a",
  "528d13c1-aa3b-4e74-8c3e-921f3428bb3c",
  "77cc7ed2-98ea-441b-a8a7-392adb2768d6",
  "f480f400-2c74-44d5-9d3e-e2cf9594a201",
  "5a314675-b0bd-466f-9675-2fc29ed72487",
  "139cd313-db8a-478d-bf30-f0caa4430bd9",
  "bffbf10c-a078-4434-b475-76363896e200",
  "18012353-515f-4f73-96f8-63e13859072f",
  "102f37dc-d510-4ccc-ad90-6d41918ccc29",
  "7ae88bcb-4b8f-4a38-81ab-b3db767aa6c0",
  "bb29227f-708b-4572-8729-78174bab2821",
  "a0880691-1dab-4b7e-887a-0e873313b980",
  "a7f56682-d9d6-4e5f-8377-9cf74138072b",
  "56ee0084-af6d-4e67-8b8f-06b876ec9d32",
  "45934d31-c092-4430-9fcb-5e6bde1a387d",
  "f27496b2-0029-40aa-b1b6-dd572145c38e",
  "8c067586-f9e7-4c59-b274-e502c814ecac",
  "e17892cf-2da1-4553-b65c-bc0f8b02fbb5",
  "70992627-22e3-44d9-992d-a2765e1b67cb",
  "3f0be3d4-a513-488f-9b35-edce4139e81e",
  "23af1d2a-d36f-4438-94cd-397f7df8766f",
  "733dcb14-d28e-4e57-a944-15d7bf4a61ea",
  "426b74f1-2860-4cd3-9f6b-b01b2945d0e1",
  "93794bff-ca5a-4e36-9194-6ef9440fcb71",
  "77482ae0-9ae4-4039-b7da-298639ea76c9",
  "b816abc2-3b7f-4a6f-81d4-211ed1e2d4ea",
  "d0d5c382-d8b8-4521-b089-99e52fdb1331",
  "e612d826-e5b4-4005-81c8-6aac7073a588",
  "cb4a1db0-19c7-41ba-9e7c-23fc08c5ed99",
  "5c2c812e-71d9-43a5-9c4e-ff499f77f75b",
  "df15dfd6-0a85-4768-a5dc-3d2ad221f61a",
  "527d26b8-0387-4bee-938b-035d0e330bf5",
  "53a9bfbb-a27e-4953-8423-92eacf630b5f",
  "587801cb-889b-49ce-bde4-bf54d561cc5a",
  "b7767728-ae57-4346-aa69-359d0de5bd6b",
  "d8da3aad-349e-41d5-8e0a-6785c79b24e1",
  "d57a123d-27c1-4ba9-9122-8245074cf42b",
  "5f2e964e-5f5f-40aa-82a2-0807e8db4843",
  "bb54b581-1be3-4fb7-9579-e47c37e9f345",
  "deb9d079-93ec-4955-a26b-ab018265b44a",
  "b7fe47b3-4ab7-4342-85b1-c03ca113b410",
  "43c27cca-beaa-48cb-a44d-06f3ee587bfd",
  "7f120a10-23e7-4aa2-a897-7cdf8fbf3169",
  "7451baa7-8440-43e3-aec8-e0faa52f098f",
  "5842191a-dd5e-41c7-9e7c-8f444fa208a2",
  "3ec2cd50-c04a-451d-a768-f51452ff8a93",
  "8f1d9cfb-8aaf-4e78-93ce-52f4a8510947",
  "f93e9185-5817-45a5-ba3d-d9762b519c86",
  "5483acab-d34f-4c3e-b9e1-2e0d1b10f37b",
  "fa985ea5-7ad3-4742-ae18-c263d7a30af6",
  "e5edff68-576a-414c-b293-6e2cc6372f31",
  "3cb9fc2d-06f4-423c-be71-b7d8cee94e5b",
  "28621f17-6ff1-4341-963d-2ea05edaf69c",
  "1fd37333-831a-4751-93bd-05562b8d00c5",
  "c4412961-a03e-486f-909f-99d03be0fe57",
  "a7f580e3-82f7-4cc0-8d93-171aeaf25540",
  "490f0c48-c130-4fb4-8dda-b82233e5ca71",
  "122bd8ec-238b-4096-b0c1-c82aca087c50",
  "17f7937b-7672-43fb-952e-2f1c3b0d77e2",
  "5b5688fc-9ce5-482a-a215-e91a6e0cefb9",
  "4534582f-5b20-462f-8ec9-4235512837c0",
  "b277c033-adc8-4ee9-a5fd-1e585c256d5d",
  "28fd2918-55b4-49bc-ba5f-ddc85e6f3d56",
  "3ed571e3-fe01-471f-b8a5-3b0fdf874223",
]

const extractTextAndFirstUrl = (text) => {
  if (typeof text !== 'string') return { link: null, parts: [text] }

  const urlRegex = /(https?:\/\/[^\s]+)/g
  const match = text.match(urlRegex)

  if (!match) {
    return { link: null, parts: [text] }
  }

  const link = match[0]
  const parts = text.split(urlRegex).filter(Boolean)

  return { link, parts }
}

export const getInputType = (
  answer,
  onChangeQuestionsInfo,
  onChangeFile,
  uploadedFiles,
  removeFile,
  loadingProcessImage,
  control,
  register,
  values,
  loadLocation = null,
  getNewLoc = () => { },
) => {
  const commonProps = {
    handleChange: (value) => onChangeQuestionsInfo(answer.type, value, answer?.id, answer),
    options: answer?.options?.map((item) => ({
      value: item,
      label: item,
    })),
    placeholder: "Selecione",
  }

  const formatFiles = (values, answer) => {
    const answerId = answer?.id
    const value = values[answerId]

    if (Array.isArray(value)) {
      return value.map((item) => item.value)
    }

    if (typeof value === "object" && value?.value?.includes("file")) {
      return value.value.split("|")
    }

    return typeof value === "string" ? value.split("|") : []
  }

  const is_baseline = baselineIds.includes(answer?.idQuestion || answer?.questionId)

  const { link: firstUrl, parts } = extractTextAndFirstUrl(answer?.subtitle)

  const questionHasLink = firstUrl ? (
    <span style={{ fontSize: "14px", color: "#666", fontStyle: "italic" }}>
      {parts.map((part, idx) =>
        part === firstUrl ? (
          <a
            key={idx}
            href={firstUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#007bff' }}
          >
            {firstUrl}
          </a>
        ) : (
          <span key={idx}> {part} </span>
        )
      )}
    </span>
  ) : null

  const baselineWarning = is_baseline && (
    <div className="baseline-warning" style={!firstUrl ? {} : { marginBottom: "10px" }}>
      <AlertIcon style={{ width: "18px", height: "18px", marginRight: "5px", color: "#FFA500" }} />
      <span style={{ fontSize: "14px", color: "#666", fontStyle: "italic" }}>
        Linha de base: este campo contém informações referentes à situação inicial.
      </span>
    </div>
  )

  switch (answer?.type) {
    case "location":
      if (loadLocation) {
        return (
          <FormRow>
            <SelectInputAsync
              selectedValue={values[answer?.id]}
              loadOptions={loadLocation}
              onChange={(value) => onChangeQuestionsInfo(answer.type, value, answer?.id, answer)}
              placeholder=""
              loadingMessage="Aguarde, estamos buscando os municípios"
              noOptionsMessage="Não há municípios com essa busca"
            />
          </FormRow>
        )
      } else {
        return (
          <Input
            type="text"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) => onChangeQuestionsInfo("text", e.target?.value, answer?.id, answer),
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
          />
        )
      }
    case "radio":
      return (
        <div
          className="edit-field-input radio"
          style={{
            overflowY: "auto",
            gap: 15,
            display: "flex",
            flexDirection: "column",
          }}>
          {baselineWarning}
          {questionHasLink}
          {commonProps.options.map(({ label, value }, index) => {
            return (
              <React.Fragment key={`${index}-${value}`}>
                <RadioButton
                  checked={values[answer?.id]?.value === value || values[answer?.id] === value}
                  classPrymary="edit-row-radio"
                  className="radio-indicators"
                  id={`${answer?.id}-${value}`}
                  text={label}
                  onChange={(e) =>
                    onChangeQuestionsInfo(answer.type, { label, value }, answer?.id, answer)
                  }
                />
              </React.Fragment>
            )
          })}
        </div>
      )
    case "geolocation":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <div className="geolocation_row">
            <Input
              type="text"
              register={
                typeof register === "function" &&
                register(`${answer?.id}`, {
                  onChange: (e) =>
                    onChangeQuestionsInfo("text", e.target?.value, answer?.id, answer),
                })
              }
              value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
              handleClick={() => getNewLoc(answer)}
              iconClick={"fi fi-rs-bullseye-pointer"}
            />
          </div>
        </div>
      )
    case "select":
    case "users":
      const isMulti =
        answer.type === "select" &&
        answer.rules?.multiple == "true";
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <FormRow>
            <SelectInput
              isOverModal={true}
              value={
                Array.isArray(values[answer.id]) || (isMulti && values[answer.id])
                  ? values[answer.id]
                  : values[answer.id] || ""
              }
              name={answer?.id}
              control={control}
              isMulti={isMulti}
              isSearchable={true}
              isClearable={true}
              resetFields={!values[answer?.id]}
              {...commonProps}
            />
          </FormRow>
        </div>
      )
    case "checkbox":
      return (
        <div
          className="edit-field-input checkbox"
          style={{
            overflowY: "auto",
            gap: 15,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {baselineWarning}
          {questionHasLink}
          {commonProps.options.map(({ label, value }, index) => {
            const currentValues = Array.isArray(values[answer?.id]) ? values[answer?.id] : [values[answer?.id]]
            const isChecked = currentValues.some((item) => item?.value === value)

            console.log({currentValues})

            const handleCheckboxChange = () => {
              const updatedValues = isChecked
                ? currentValues.filter((item) => item.value !== value)
                : [...currentValues, { label, value }]
              onChangeQuestionsInfo(answer.type, updatedValues, answer?.id, answer)
            }

            return (
              <div key={`${index}-${value}`} className="checkbox-item" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <input
                  type="checkbox"
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: "pointer",
                  }}
                  id={`${index}-${value}`}
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor={`${index}-${value}`}>
                  {label}
                </label>
              </div>
            )
          })}
        </div>
      )
    case "textarea":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <TextArea
            className="inputArea"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) =>
                  onChangeQuestionsInfo("textarea", e.target?.value, answer?.id, answer),
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
            hasFocus={true}
          />
        </div>
      )
    case "date":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <Input
            type="date"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) => onChangeQuestionsInfo("date", e.target?.value, answer?.id, answer),
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
          />
        </div>
      )
    case "file":
      return (
        <div className={`upload-button-evidence ${is_baseline ? `baseline-group` : ``}`} style={{ display: "flex", gap: "12px" }}>
          {baselineWarning}
          {questionHasLink}
          <InputFileWithPreview
            name="files"
            accept="image/png,image/jpeg,image/jpg,video/mp4"
            handleChangeFile={(e) =>
              onChangeFile(e, answer?.id || answer, formatFiles(values, answer))
            }
            uploaded={formatFiles(values, answer)}
            loadingProcessImage={loadingProcessImage === (answer?.id || answer)}
            isMultiple={true}
          />
        </div>
      )
    case "tel":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <Input
            placeholder="(99) 9 9999-9999"
            type="text"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) =>
                  onChangeQuestionsInfo("text", phoneMask(e.target?.value), answer?.id, answer),
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
            min="14"
            max="15"
            {...(isMobile ? { ...{ type: "tel" } } : {})}
          />
        </div>
      )
    case "datetime":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <Input
            type="datetime-local"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) =>
                  onChangeQuestionsInfo("dateTime", e.target?.value, answer?.id, answer),
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
            min="14"
            max="15"
          />
        </div>
      )
    case "number":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <Input
            type="number"
            inputMode={"decimal"}
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) =>
                  onChangeQuestionsInfo("number", numberMask(e.target?.value), answer?.id, answer),
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
          />
        </div>
      )
    case "email":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <Input
            type="email"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) =>
                  onChangeQuestionsInfo("email", e.target?.value, answer?.id, answer),
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
          />
        </div>
      )
    case "table":
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <TableInput
            answer={answer}
            onChangeQuestionsInfo={onChangeQuestionsInfo}
            register={register}
            values={values}
            getInputType={getInputType}
          />
        </div>
      )
    default:
      return (
        <div className="baseline-group">
          {baselineWarning}
          {questionHasLink}
          <Input
            type="text"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) => {
                  console.log({ e })
                  onChangeQuestionsInfo("text", e.target?.value, answer?.id, answer)
                },
              })
            }
            value={(values && (values[answer?.id]?.value || values[answer?.id])) || ""}
          />
        </div>
      )
  }
}

const renderStepFields = (
  fields,
  conditionalAnswers,
  index,
  onChangeQuestionsInfo,
  onChangeFile,
  onChangeFileEvidence,
  uploadedFiles,
  removeFile,
  loadingProcessImage,
  control,
  register,
  values,
  valuesQuestions,
  loadLocation,
  getNewLoc,
  hasEvidence = false,
  handleOpenEvidence,
  handleRemoveEvidence,
  pinnedMessagesQuestions,
  removeMessages,
) => {
  return fields.map((answer, answerIndex) => {
    const answerValues = Array.isArray(conditionalAnswers[answer?.conditionalQuestion])
      ? conditionalAnswers[answer?.conditionalQuestion].map((item) => item?.value)
      : null

    const hasMatchingValue =
      Array.isArray(answerValues) &&
      answerValues.some((value) => answer?.conditionalAnswer?.includes(value))

    const shouldRenderField =
      !answer?.isConditional ||
      ((conditionalAnswers[answer?.conditionalQuestion]?.value ||
        conditionalAnswers[answer?.conditionalQuestion]) &&
        answer?.conditionalAnswer
          ?.split("|")
          .includes(
            conditionalAnswers[answer?.conditionalQuestion]?.value ||
            conditionalAnswers[answer?.conditionalQuestion],
          )) ||
      hasMatchingValue

    return shouldRenderField ? (
      <div className="questions-container" key={answer?.id}>
        <div className="question-inputs">
          <div className="labelContainer">
            <Label
              className="questionTitle"
              label={`${answerIndex + 1}. ${answer.title}`}
              subtitle={answer.type !== "table" ? answer.info || answer.subtitle : ""}
            />
          </div>
          <div className="input-section">
            <div className={hasEvidence ? `input-group-evidence` : ``}>
              {getInputType(
                answer,
                onChangeQuestionsInfo,
                onChangeFile,
                uploadedFiles,
                removeFile,
                loadingProcessImage,
                control,
                register,
                values,
                loadLocation,
                getNewLoc,
              )}
              {hasEvidence && !answer?.title?.toLowerCase()?.includes("evid") && (
                <InfoTooltip
                  info="Adicionar evidência"
                  trigger="hover"
                  children={
                    <div className="add_button" onClick={() => handleOpenEvidence(answer?.id)} />
                  }
                />
              )}
            </div>
            {valuesQuestions?.[`${answer?.id}-evidence`]?.length > 0 && (
              <div className="pinned-messages-container">
                <EvidenceBox
                  questionId={answer?.id}
                  hasActions={true}
                  handleRemoveEvidence={handleRemoveEvidence}
                  evidences={valuesQuestions[`${answer?.id}-evidence`]}
                />
              </div>
            )}
            {pinnedMessagesQuestions?.[`${answer?.id}-messages`]?.length > 0 && (
              <>
                <div className="pinned-messages-container">
                  {pinnedMessagesQuestions?.[`${answer?.id}-messages`].map((message) => (
                    <div key={message?.id}>
                      <MessageBox
                        message={message}
                        questionId={answer?.id}
                        hasActions
                        removePinnedMessage={removeMessages}
                      />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    ) : null
  })
}

const QuestionsCard = ({ children, handleBack, handleClose }) => (
  <Card className="assistance-link-questions">
    {isMobile && (typeof handleBack === "function") && (
      <CardTitle
        title={
          <div className="assistance-header-questions">
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
              <button
                style={{ height: "40px", width: "40px", backgroundColor: "#f2f2f2", borderRadius: "100%" }}
                className="button-back"
                onClick={handleBack}>
                <i className="fi fi-sr-arrow-small-left" />
              </button>
              <button
                style={{ height: "30px", width: "30px", backgroundColor: "#f2f2f2", borderRadius: "100%" }}
                className="button-back"
                onClick={handleClose}>
                <MdClose />
              </button>
            </div>
          </div>
        }
      />
    )}
    {!isMobile && (
      <CardTitle title={<div className="assistance-header-questions"><span>Questões</span></div>} />
    )}
    {children}
  </Card>
)

const EvidenceSection = ({
  isMobile,
  openEvidenceScreen,
  uploadedFilesEvidence,
  loadingProcessImage,
  valuesQuestions,
  pinnedMessagesQuestions,
  handleRemoveEvidence,
  handleUploadPhotos,
  onChangeFileEvidence,
  removeMessages,
  hasPinnedQuestions
}) => {
  if (!openEvidenceScreen) return null;

  return (
    <div className={`questions-evidence ${isMobile ? "questions-evidence-mobile" : ""} ${!hasPinnedQuestions && isMobile ? "questions-alert" : ""}`}>
      <div className="link_assistance_input">
        <h2>Anexar Novos Arquivos</h2>
        <div className="upload-button-evidence" style={{ display: "flex", gap: "12px", flexDirection: "column" }}>
          <InputFileWithPreview
            name="files"
            accept="image/png,image/jpeg,image/jpg,video/mp4,.doc,docx,.xls,xlsx,.pdf,.ppt,.pptx"
            handleChangeFile={(e) => onChangeFileEvidence(e, openEvidenceScreen)}
            clearPreview={uploadedFilesEvidence?.length > 0}
            loadingProcessImage={loadingProcessImage === openEvidenceScreen}
            isMultiple={true}
          />
          <CameraGallery
            questionId={openEvidenceScreen}
            handleUploadPhotos={handleUploadPhotos}
          />
        </div>
      </div>

      {valuesQuestions?.[`${openEvidenceScreen}-evidence`]?.length > 0 && (
        <div className="pinned-messages-container" key={openEvidenceScreen}>
          <InfoTitle
            info="Arquivos"
            counter={valuesQuestions[`${openEvidenceScreen}-evidence`]}
          />
          <EvidenceBox
            questionId={openEvidenceScreen}
            hasActions
            handleRemoveEvidence={handleRemoveEvidence}
            evidences={valuesQuestions[`${openEvidenceScreen}-evidence`]}
          />
        </div>
      )}

      {hasPinnedQuestions && (
        <>
          <InfoTitle
            info="Mensagens"
            counter={pinnedMessagesQuestions?.[`${openEvidenceScreen}-messages`]}
          />
          <div className="pinned-messages-container">
            {pinnedMessagesQuestions?.[`${openEvidenceScreen}-messages`].map((message) => (
              <div key={message?.id}>
                <MessageBox message={message} hasActions removePinnedMessage={removeMessages} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

const StepsSection = ({
  isMobile,
  openEvidenceScreen,
  stepQuestions,
  geolocation,
  handleChangeGeoLocation,
  getNewLoc,
  conditionalAnswers,
  onChangeQuestionsInfo,
  onChangeFile,
  onChangeFileEvidence,
  uploadedFiles,
  removeFile,
  loadingProcessImage,
  control,
  register,
  values,
  valuesQuestions,
  loadLocation,
  handleOpenEvidence,
  handleRemoveEvidence,
  pinnedMessagesQuestions,
  removeMessages,
  startedAt,
  hashId
}) => {
  if (!stepQuestions?.steps?.length) return null;

  return (
    <div className="questions" style={{ display: openEvidenceScreen ? "none" : "block" }}>
      {startedAt && <div style={{ marginBottom: 8 }}>
        <p style={{ fontSize: 14 }}>Iniciado em {startedAt.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })}</p>
      </div>}
      <div style={{ marginBottom: 8 }}>
        <Label label="Localização ao preencher formulário" />
        <Input
          placeholder="Localização"
          onChange={handleChangeGeoLocation}
          value={geolocation || ""}
          hasFocus={false}
          handleClick={(e) => getNewLoc(null)}
          iconClick="fi fi-rs-bullseye-pointer"
        />
      </div>
      {stepQuestions.steps.map((sq, index) => (
        <div key={sq?.id}>
          <h1>Etapa: {sq?.title}</h1>

          {hashId ? (
            Array.isArray(sq.groups) && sq.groups.map((group) => (
              <div key={group.groupId}>
                <h4>Grupo: {group.groupTitle}</h4>
                {Array.isArray(group.fields) &&
                  renderStepFields(
                    group.fields,
                    conditionalAnswers,
                    index,
                    onChangeQuestionsInfo,
                    onChangeFile,
                    onChangeFileEvidence,
                    uploadedFiles,
                    removeFile,
                    loadingProcessImage,
                    control,
                    register,
                    values,
                    valuesQuestions,
                    loadLocation,
                    getNewLoc,
                    isMobile,
                    handleOpenEvidence,
                    handleRemoveEvidence,
                    pinnedMessagesQuestions,
                    removeMessages
                  )}
              </div>
            ))
          ) : (
            Array.isArray(sq.fields) &&
            renderStepFields(
              sq.fields,
              conditionalAnswers,
              index,
              onChangeQuestionsInfo,
              onChangeFile,
              onChangeFileEvidence,
              uploadedFiles,
              removeFile,
              loadingProcessImage,
              control,
              register,
              values,
              valuesQuestions,
              loadLocation,
              getNewLoc,
              isMobile,
              handleOpenEvidence,
              handleRemoveEvidence,
              pinnedMessagesQuestions,
              removeMessages
            )
          )}
        </div>
      ))}

    </div>
  );
}

const QuestionsContent = ({
  handleBack,
  handleClose,
  containerRef,
  filterOpen,
  stepQuestions,
  openEvidenceScreen,
  uploadedFilesEvidence,
  loadingProcessImage,
  valuesQuestions,
  pinnedMessagesQuestions,
  handleRemoveEvidence,
  handleUploadPhotos,
  onChangeFileEvidence,
  removeMessages,
  hasPinnedQuestions,
  geolocation,
  handleChangeGeoLocation,
  getNewLoc,
  conditionalAnswers,
  onChangeQuestionsInfo,
  onChangeFile,
  uploadedFiles,
  removeFile,
  control,
  register,
  values,
  loadLocation,
  handleOpenEvidence,
  saving,
  handleCloseEvidence,
  saveFormSubmission,
  startedAt,
  hashId
}) => {
  return (
    <QuestionsCard handleBack={handleBack} handleClose={handleClose}>
      <div
        className={`assistance-link-questions__container ${isMobile ? "assistance-link-questions__container-mobile" : ""}`}
        ref={containerRef}
        style={!isMobile ? { overflowY: "auto", maxHeight: "100vh" } : {}}
      >
        <section className={`questions-content ${!filterOpen ? "size" : ""}`}>
          <span style={{ fontWeight: "bold", fontSize: "24px" }}>
            {stepQuestions.producers.map((item) => item.form)}
          </span>

          <EvidenceSection
            isMobile={isMobile}
            openEvidenceScreen={openEvidenceScreen}
            uploadedFilesEvidence={uploadedFilesEvidence}
            loadingProcessImage={loadingProcessImage}
            valuesQuestions={valuesQuestions}
            pinnedMessagesQuestions={pinnedMessagesQuestions}
            handleRemoveEvidence={handleRemoveEvidence}
            handleUploadPhotos={handleUploadPhotos}
            onChangeFileEvidence={onChangeFileEvidence}
            removeMessages={removeMessages}
            hasPinnedQuestions={hasPinnedQuestions}
          />

          <StepsSection
            isMobile={isMobile}
            openEvidenceScreen={openEvidenceScreen}
            stepQuestions={stepQuestions}
            geolocation={geolocation}
            handleChangeGeoLocation={handleChangeGeoLocation}
            getNewLoc={getNewLoc}
            conditionalAnswers={conditionalAnswers}
            onChangeQuestionsInfo={onChangeQuestionsInfo}
            onChangeFile={onChangeFile}
            onChangeFileEvidence={onChangeFileEvidence}
            uploadedFiles={uploadedFiles}
            removeFile={removeFile}
            loadingProcessImage={loadingProcessImage}
            control={control}
            register={register}
            values={values}
            valuesQuestions={valuesQuestions}
            loadLocation={loadLocation}
            handleOpenEvidence={handleOpenEvidence}
            handleRemoveEvidence={handleRemoveEvidence}
            pinnedMessagesQuestions={pinnedMessagesQuestions}
            removeMessages={removeMessages}
            startedAt={startedAt}
            hashId={hashId}
          />

          <div className="questions-button-save">
            {openEvidenceScreen ? (
              <Button
                color="primary"
                label="Salvar"
                isDisabled={loadingProcessImage === openEvidenceScreen}
                handleClick={handleCloseEvidence}
              />
            ) : (
              <ButtonLoader
                color="primary"
                label="Salvar"
                messageProcess="Salvando Questões..."
                loading={saving}
                handleClick={saveFormSubmission}
              />
            )}
          </div>
        </section>
      </div>
    </QuestionsCard>
  );
}

export default function AssistanceLinkFormStepsScreen({
  loadingQuestions,
  pinnedMessagesQuestions,
  saving,
  stepQuestions,
  handleChangeSteps,
  setQuestionsSearchTerm,
  questionsSearchTerm,
  stepOptions,
  stepsFilter,
  groupOptions,
  onChangeFile,
  onChangeFileEvidence,
  onChangeQuestionsInfo,
  uploadedFiles,
  removeFile,
  loadingProcessImage,
  control,
  register,
  values,
  saveFormSubmission,
  saved,
  valuesQuestions,
  formId,
  userId,
  handleBack,
  handleBackIsOffline,
  handleClose,
  loadLocation,
  getNewLoc,
  geolocation,
  handleChangeGeoLocation,
  conditionalAnswers,
  filterOpen,
  setFilterOpen,
  handleOpenEvidence,
  handleCloseEvidence,
  openEvidenceScreen,
  uploadedFilesEvidence,
  isSystemChat,
  setIsSystemChat,
  openChatModal,
  handleOpenChatModal,
  handleCloseChatModal,
  removeMessages,
  handleUploadPhotos,
  handleRemoveEvidence,
  startedAt,
  isLoadingTestimonial,
  isFilled,
  hashId
}) {
  const containerRef = useRef(null)
  const scrollTopRef = useRef(0)
  const [prevHeight, setPrevHeight] = useState(0)

  // Armazena a posição antes de renderizar a nova lista
  useLayoutEffect(() => {
    if (containerRef.current) {
      scrollTopRef.current = containerRef.current.scrollTop
      setPrevHeight(containerRef.current.scrollHeight)
    }
  }, [stepQuestions])

  // Restaura a posição após o DOM atualizar
  useEffect(() => {
    if (containerRef.current) {
      const newHeight = containerRef.current.scrollHeight
      const scrollDiff = newHeight - prevHeight
      containerRef.current.scrollTop = scrollTopRef.current + scrollDiff
    }
  }, [stepQuestions])

  const hasPinnedQuestions = pinnedMessagesQuestions?.[`${openEvidenceScreen}-messages`]?.length > 0

  return (
    <>
      <Overlay loading={saving} label="Salvando questões, aguarde..." />
      {handleBackIsOffline && (
        <div className="beneficiary-header">
          <div className="form-header">
            {openEvidenceScreen ? (
              <>
                <div style={{ display: "flex", gap: "10px", flex: 1 }}>
                  <button
                    disabled={
                      loadingProcessImage && openEvidenceScreen
                        ? loadingProcessImage === openEvidenceScreen
                        : false
                    }
                    className="button-back"
                    onClick={handleCloseEvidence}>
                    <i className="fi fi-sr-arrow-small-left" />
                  </button>
                  <span>Evidências</span>
                </div>
              </>
            ) : (
              <>
                <div style={{ display: "flex", gap: "10px", flex: 1 }}>
                  <button className="button-back" onClick={handleBackIsOffline}>
                    <i className="fi fi-sr-arrow-small-left" />
                  </button>
                  <span>Novo registro</span>
                </div>
                <button className="button-filter" onClick={() => setFilterOpen((open) => !open)}>
                  <i className={filterOpen ? "fi fi-sr-filter-slash" : "fi fi-sr-filter"} />
                </button>
              </>
            )}
          </div>
          {filterOpen && (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <div style={{ padding: "0px 15px" }}>
                <Label label="Etapas" />
                <SelectInput
                  options={groupOptions}
                  isSearchable={true}
                  isClearable={true}
                  handleChange={(e) => handleChangeSteps("groups", e?.value)}
                />
              </div>
              <div style={{ padding: "0px 15px" }}>
                <Label label="Grupos" />
                <SelectInput
                  options={stepOptions}
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={!stepsFilter?.groups}
                  resetFields={stepsFilter?.groups || !stepsFilter?.groups}
                  handleChange={(e) => handleChangeSteps("steps", e?.value)}
                />
              </div>
              <div style={{ padding: "0px 15px" }}>
                <Label label="Filtrar perguntas" />
                <Input
                  placeholder="Pesquise pelo nome da pergunta"
                  onChange={(e) => setQuestionsSearchTerm(e.target.value)}
                  value={questionsSearchTerm}
                  hasIcon={<i class="fi fi-rr-search"></i>}
                  hasFocus={false}
                // handleClick={handleClick}
                // iconClick="fi fi-rr-add"
                />
              </div>
            </div>
          )}
        </div>
      )}
      <div className="assistance-link-questions-open-form">
        {openEvidenceScreen && (
          <>
            {hasPinnedQuestions ? (
              <></>
            ) : (
              <div style={{ marginBottom: 16 }}>
                <Warning
                  label={
                    isMobile
                      ? `Para vincular uma evidência ao atendimento, clique no ícone do chat para adicionar mensagens o selecione um arquivo.`
                      : `Para vincular uma evidência ao atendimento, clique no ícone '+' ao lado do chat para adicionar mensagens ou selecione um arquivo para upload.`
                  }
                />
              </div>
            )}
          </>
        )}
        {!saved && !isFilled ? (
          <>
            {loadingQuestions ? (
              <Card className="assistance-link-questions no-questions" ref={containerRef}>
                <LoadingWithLabel colorSpinner="primary" labelLoading="Buscando Questões..." />
              </Card>
            ) : stepQuestions && stepQuestions.steps && stepQuestions.producers ? (
              <QuestionsContent
                handleBack={handleBack}
                handleClose={handleClose}
                containerRef={containerRef}
                filterOpen={filterOpen}
                stepQuestions={stepQuestions}
                openEvidenceScreen={openEvidenceScreen}
                uploadedFilesEvidence={uploadedFilesEvidence}
                loadingProcessImage={loadingProcessImage}
                valuesQuestions={valuesQuestions}
                pinnedMessagesQuestions={pinnedMessagesQuestions}
                handleRemoveEvidence={handleRemoveEvidence}
                handleUploadPhotos={handleUploadPhotos}
                onChangeFileEvidence={onChangeFileEvidence}
                removeMessages={removeMessages}
                hasPinnedQuestions={hasPinnedQuestions}
                geolocation={geolocation}
                handleChangeGeoLocation={handleChangeGeoLocation}
                getNewLoc={getNewLoc}
                conditionalAnswers={conditionalAnswers}
                onChangeQuestionsInfo={onChangeQuestionsInfo}
                onChangeFile={onChangeFile}
                uploadedFiles={uploadedFiles}
                removeFile={removeFile}
                control={control}
                register={register}
                values={values}
                loadLocation={loadLocation}
                handleOpenEvidence={handleOpenEvidence}
                saving={saving}
                handleCloseEvidence={handleCloseEvidence}
                saveFormSubmission={saveFormSubmission}
                startedAt={startedAt}
                hashId={hashId}
              />
            ) : (
              <Card className="assistance-link-questions no-questions">
                <h1>Sem Questões</h1>
              </Card>
            )}
            <ModalPanel modalIsOpen={openChatModal}>
              <Overlay loading={isLoadingTestimonial}>Teste</Overlay>
              <Section
                className={`farmer-section farmer-section__chat ${isSystemChat ? "system_chat" : ""
                  }`}>
                <Section className="farmer-section__chat-container">
                  <NewChatContainer
                    changeCurrentChat={(value) => setIsSystemChat(value)}
                    defaultChat={userId}
                    showOnlyChat
                    isMobile
                    indicators={[]}
                    showActions
                    handleCloseModal={handleCloseChatModal}
                    handleNavigateToEvidence={handleCloseChatModal}
                    formQuestionMessage={{}}
                    pinnedQuestions={[]}
                  />
                </Section>
              </Section>
            </ModalPanel>
            {isMobile && openEvidenceScreen && (
              <div className="chat-button">
                <BsChatText onClick={handleOpenChatModal} />
              </div>
            )}
          </>
        ) : (
          <Card className="assistance-link-questions no-questions">
            {hashId && <h1>O Formulário já foi respondido</h1>}
            {handleClose && <Button color="primary" label="Voltar" handleClick={handleClose} />}
          </Card>
        )}
      </div>
    </>
  )
}
